module.exports = __webpack_public_path__ + "fonts/fa-regular-400.dd012cb9.woff";